import { CompanyType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import * as yup from 'yup';

import { humanReadableCompanyTypes } from '~components/FormFields/CommonAutocompletes/AutocompleteCompanyTypes';
import { AutocompleteFieldOption } from '~components/FormFields/v2/Autocomplete/types';
import { Account } from '~hooks/useAccount/models';

export const accountConfigurationSchema = yup.object().shape({
  isEditing: yup.boolean().required(),
  accountTypes: yup
    .array()
    .of(yup.string().oneOf(['customer', 'vendor']))
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
  companyType: yup.object().when('isEditing', {
    is: true,
    then: (schema) => {
      return schema
        .shape({ label: yup.string().notRequired(), value: yup.string().notRequired() })
        .notRequired();
    },
    otherwise: (schema) => {
      return schema
        .shape({ label: yup.string().required(), value: yup.string().required() })
        .required(t('form_validation_errors.required_simple'));
    },
  }),
  jobsSplittable: yup.boolean().notRequired(),
  equipmentOptionsRestricted: yup.boolean().notRequired(),
});
export type AccountConfigurationDto = yup.InferType<typeof accountConfigurationSchema>;

export function setAccountConfigurationSchemaDefaultValues(account?: Account) {
  const companyType = account?.connectedCompany?.companyType as CompanyType | undefined;
  const companyTypeDefaultValue = companyType
    ? { label: humanReadableCompanyTypes[companyType], value: companyType }
    : null;

  const defaultValues: AccountConfigurationDto = {
    isEditing: Boolean(account?.id),
    accountTypes: account?.accountTypes || ['vendor'],
    companyType: companyTypeDefaultValue as AutocompleteFieldOption<CompanyType>,
    jobsSplittable: account?.jobsSplittable ?? false,
    equipmentOptionsRestricted: account?.equipmentOptionsRestricted ?? false,
  };

  return defaultValues;
}
